import script from "./TournamentFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentFeatures.vue?vue&type=script&setup=true&lang=js"

import "./TournamentFeatures.vue?vue&type=style&index=0&id=53a27078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a27078"]])

export default __exports__